import { KYMW0901Model } from '../kymw0901.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessViewUtilsSub } from 'src/app/commons/kymw00/pless-view-utils-sub.service';

/**
 * 供給計画取得クラス
 *
 * @export SaveChangeFixationService
 * @class SaveChangeFixationService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class SaveChangeFixationService extends PlessJsonResponderSub<any> {

  // VO
  private model: KYMW0901Model = new KYMW0901Model;
  private vo: any;

  // 処理に使用するModel
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /** 変更項目のパラメーターを設定 */
  private setChangeItemParameter(item) {
    if (!PlessViewUtilsSub.isEmpty(item)) {
      return {
        ChangeItemName: item.changeItemName,
        ChangeItemNum: item.changeItemNum,
        ChangeItemIndex: item.changeItemIndex,
        SkewerSelect: item.skewerSelect ? '1' : '0'
      }
    } else {
      return {}
    }
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof SaveChangeFixationService
   */
  private getBody(): PlessRequest {
    let requestData = [];

    // リプレース時から既存のCommonItem, CoopItem, ItemCodeItemは空の場合でもcombination[]で渡す
    // 次回案内情報
    if (!PlessViewUtilsSub.isEmptyArray(this.vo.nextGuideItem)) {
      requestData['NextGuide'] = {
        combination: this.vo.nextGuideItem.map(item => {
          return {
            parameter: {
              CoopCode: item.coopCode,
              MediumType: item.mediumType,
              ...this.setChangeItemParameter(item),
            }
          }
        })
      }
    }
    // 企画商品抽選商品プロモーション情報
    if (!PlessViewUtilsSub.isEmptyArray(this.vo.lotteryPromotionItem)) {
      requestData['LotteryPromotion'] = {
        combination: this.vo.lotteryPromotionItem.map(item => {
          return {
            parameter: {
              KeyCode: item._keyCode,
              ...this.setChangeItemParameter(item),
            }
          }
        })
      }
    }
    // 企画商品クーポンプロモーション情報
    if (!PlessViewUtilsSub.isEmptyArray(this.vo.couponPromotionItem)) {
      requestData['CouponPromotion'] = {
        combination: this.vo.couponPromotionItem.map(item => {
          return {
            parameter: {
              KeyCode: item._keyCode,
              ...this.setChangeItemParameter(item),
            }
          }
        })
      }
    }
    // 企画商品会員生協別クーポン値引額管理情報
    if (!PlessViewUtilsSub.isEmptyArray(this.vo.couponApplicablePriceItem)) {
      requestData['CouponApplicablePrice'] = {
        combination: this.vo.couponApplicablePriceItem.map(item => {
          return {
            parameter: {
              KeyCode: item._keyCode,
              CoopCode: item.coopCode,
              ...this.setChangeItemParameter(item),
            }
          }
        })
      }
    }
    // 企画商品ポイント交換基本情報
    if (!PlessViewUtilsSub.isEmptyArray(this.vo.pointExchangeBaseItem)) {
      requestData['PointExchangeBase'] = {
        combination: this.vo.pointExchangeBaseItem.map(item => {
          return {
            parameter: {
              ItemCode: item.itemCode,
              ...this.setChangeItemParameter(item),
            }
          }
        }) 
      }
    }
    // 企画商品ポイント交換利用生協情報
    if (!PlessViewUtilsSub.isEmptyArray(this.vo.pointExchangeCoopItem)) {
      requestData['PointExchangeCoop'] = {
        combination: this.vo.pointExchangeCoopItem.map(item => {
          return {
            parameter: {
              CoopCode: item.coopCode,
              ItemCode: item.itemCode,
              ...this.setChangeItemParameter(item),
            }
          }
        })
      }
    }
    // 企画商品1物N価媒体プロモーション情報 
    if (!PlessViewUtilsSub.isEmptyArray(this.vo.planGoodsNvalPromotionItem)) {
      requestData['PlanGoodsNvalPromotion'] = {
        combination: this.vo.planGoodsNvalPromotionItem.map(item => {
          return {
            parameter: {
              NvalDetailId: item._nvalDetailId,
              MediumType: item.mediumType,
              ItemCode: item.itemCode,
              ...this.setChangeItemParameter(item),
            }
          }
        })
      }
    }
    // EC情報タブ情報
    if (!PlessViewUtilsSub.isEmptyArray(this.vo.planGoodsECItem)) {
      requestData['PlanGoodsEC'] = {
        combination: this.vo.planGoodsECItem.map(item => {
          return {
            parameter: {
              ...this.setChangeItemParameter(item),
            }
          }
        })
      }
    }
    // 企画商品会員生協別EC在庫限定情報
    if (!PlessViewUtilsSub.isEmptyArray(this.vo.planGoodsCoopECStockItem)) {
      requestData['PlanGoodsCoopECStock'] = {
        combination: this.vo.planGoodsCoopECStockItem.map(item => {
          return {
            parameter: {
              CoopCode: item.coopCode,
              ...this.setChangeItemParameter(item),
            }
          }
        }) 
      }
    }
    // 企画商品予約基本情報
    if (!PlessViewUtilsSub.isEmptyArray(this.vo.planGoodsPreOrderItem)) {
      requestData['PlanGoodsPreOrder'] = {
        combination: this.vo.planGoodsPreOrderItem.map(item => {
          return {
            parameter: {
              PreOredeDetailId: item.preOredeDetailId,
              ...this.setChangeItemParameter(item),
            }
          }
        })
      }
    }
    // 企画商品予約詳細情報
    if (!PlessViewUtilsSub.isEmptyArray(this.vo.planGoodsPreOrderCoopItem)) {
      requestData['PlanGoodsPreOrderCoop'] = {
        combination: this.vo.planGoodsPreOrderCoopItem.map(item => {
          return {
            parameter: {
              PreOredeDetailId: item.preOredeDetailId,
              ...this.setChangeItemParameter(item),
            }
          }
        })
      }
    }

    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.orderCode,
        PCode: this.vo.pCode,
        MediumType: this.model.selectedMediumType,
      },
      update: {
        CommonItem: {                                                       // 共通項目
          combination: this.vo.commonItem.map(item => {
            return {
              parameter: {
                ...this.setChangeItemParameter(item),
              }
            }
          })
        },
        CoopItem: {                                                         // 会員生協
          combination: this.vo.coopItem.map(item => {
            return {
              parameter: {
                CoopCode: item.coopCode,
                ...this.setChangeItemParameter(item),
              }
            }
          })
        },
        ItemCodeItem: {                                                     // アイテムコード
          combination: this.vo.itemCodeItem.map(item => {
            return {
              parameter: {
                ItemCode: item.itemCode,
                ...this.setChangeItemParameter(item),
              }
            }
          })
        },
        ...requestData,
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model 処理に使用するモデル
   * @param vo vo
   * @param successFunc 成功時に実行される処理
   * @memberof SaveChangeFixationService
   */
  execute(model: KYMW0901Model, vo: any, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('KYMW09saveChangeFixation', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof SaveChangeFixationService
   */
  success(data: any): void {
    this.model.saveChangeFixation(data);
  }
}
